<style lang="scss">
	.modal{
		font-size: 14px;
		// background-color: rgba(255, 255, 255, 0.95) !important;
		.p-x {
			padding-right: 2rem;
		}
		.text-lg {
			font-size: 60px;
		}
		.modal-close-btn {
			height: 70px;
		}
		h4 {
			padding-bottom: 50px;
			color: #8f40b0;
			font-size: 30px;
			font-weight: 600;
			text-transform: uppercase;
		}
		h6 {
			color: #8f40b0;
			font-size: 17px;
		}
		.btn {
			padding: 15px 70px;
		}
		.btn-block {
			padding: 15px;
		}

		@media (max-width: 767px) {
			.top-modal {
				padding-top: 40px;
			}

			h4 {
				padding-bottom: 10px;
				font-size: 26px;
			}
		}
		@media (max-width: 450px) {
			h4 {
				font-size: 24px;
			}
		}
	}
	.cart-modal {
		.cart-item-type {
			background: #4B4B4B;
		}
		.empty-cart {
			border-top: none;
			text-align: right;
			a {
				color: #0275d8;
			}
		}
		.discount-applied-message {
			position: relative;
			.remove-license {
				position: absolute;
				right: 0;
				top: 0;
				cursor: pointer;
				padding: 4px;
				font-size: 14px;
				color: #cd6c6c;
			}
		}
		.top-modal{
			display : flex;
			justify-content: space-between;
			.share-button{
				margin-top: 8px;
    			min-width: 67px;
			}
		}

		.total-wrapper{
			padding-bottom: 10px !important;
		}
		.cart-row-beat-container{
			.item-media-colomn{
				display: block !important;
			}

			.price{
    			text-align: center;
			}

		}

		.checkout-button{
			color : #fff;
			border-radius : 5px;
			padding: 10px 20px !important;
			margin-top: 30px;

		}

		.continue-button{
			color : #ffffff !important;
			padding: 10px 20px !important;
			margin-top: 30px;
		}

		.contact{
			margin-top: 50px;
		}

		.url-link{
			color: #ff5b94;
			font-family: Poppins;
			font-size: 14px;
			font-weight: 500;
		}

		.cart-total {
			.total-wrapper-empty {
				text-align: right;
			}
		}

		&__package-deals {
			display: block;
			background-color: var(--faded-highlight-text-color);
			padding: 1rem 0rem;
			margin-top: 2rem;
			margin-left: -4rem;
			margin-right: -3rem;

			&--wrapper {
				width: 100%;
				padding-left: 4rem;
				padding-right: 3rem;

				.continue-button {
					width: 100%;
					margin-top: 5px;

					&__svg {
						width: 10px;
						fill: currentColor;
					}
				}

				&-content {
					text-align: left;
					font-size: 11px !important;
					display: block;
				}
			}
		}
	}

    @media screen and (max-width: 768px) {
			.cart-modal{
				.top-modal{
					.share-button{
						margin-top: 2px;
					}
				}
							.cart-row-beat-container{
					.price{
						font-weight: 600 !important;
						margin-top: 25px !important;
						text-align: center !important;
					}
				}

				.actions{
					.checkout-button{
						width: 100% !important;

					}

					.continue-button{
						width: 100% !important;
						margin-top: 20px !important;
					}
				}

				.cart-total {
					.total-wrapper-empty {
						text-align: center;
					}
				}
			}
    }

	 @media screen and (max-width: 363px) {
		 .cart-modal{
			.cart-row-beat-container{
				.price{
					margin-top: 5px !important;
				}
			}
		 }
    }
</style>

<template>
	<div class="cart-modal modal fade" id="cartModal" :style="$modalBackgroundStyle">
		<a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
		 <div class="row-col">
       <div class="tw-pt-14 tw-px-8 h-v row-cell v-m">
                <div class="row">
                    <div class="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <div class="row">
                            <div class="row item-list item-list-sm item-list-by m-b">
                                <div class="col-xs-12">
                   <h4 class="modal-title tw-mt-4 tw-mb-1" :style="$highlightColor">SHOPPING CART</h4>
                   <cart-items-list theme="checkout" />
                   <div class="tw-mt-3" v-if="!cartEmpty">
                     <checkout-total />
                   </div>
                   <div class="tw-text-infinity-primary-text tw-m-4 tw-text-center" v-else>
                     Your cart is empty.
                   </div>
									<div class="cart-modal__package-deals" v-if="showPackageDiscountsNotice" :style="styles">
										<div class="cart-modal__package-deals--wrapper">
											<span class="cart-modal__package-deals--wrapper-content">
												Add more {{ licensesInCart }} license(s) to benefit from package discounts.
											</span>

											<button class="btn btn-success continue-button" @click="showPackageDiscounts">
												<svg class="continue-button__svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 12 19"><defs><path id="b4qqa" d="M1258.94 20a.6.6 0 0 0-.6.6v4.74a.6.6 0 0 0 1.2 0V20.6a.6.6 0 0 0-.6-.59z"/><path id="b4qqb" d="M1260.13 34.85a.6.6 0 1 1 1.18 0 .6.6 0 0 1-1.18 0z"/><path id="b4qqc" d="M1256.56 30.1a.6.6 0 1 1 1.2 0 .6.6 0 0 1-1.2 0z"/><path id="b4qqd" d="M1260.72 36.63a1.78 1.78 0 1 1 0-3.57 1.78 1.78 0 0 1 0 3.57zm-4.75 0a.6.6 0 0 1-.46-.98l5.94-7.12a.6.6 0 0 1 .91.76l-5.94 7.13a.6.6 0 0 1-.45.2zm1.19-8.32a1.78 1.78 0 1 1 0 3.57 1.78 1.78 0 0 1 0-3.57zm4.4-5.93h-.84v2.96a1.78 1.78 0 0 1-3.56 0v-2.96h-.84l-3.32 3.31v12.13c0 .65.53 1.18 1.19 1.18h9.5c.66 0 1.19-.53 1.19-1.18V25.69z"/></defs><g><g transform="translate(-1253 -20)"><g><g><g><use xlink:href="#b4qqa"/></g></g></g><g><g><g><use xlink:href="#b4qqb"/></g></g></g><g><g><g><use xlink:href="#b4qqc"/></g></g></g><g><g><g><use xlink:href="#b4qqd"/></g></g></g></g></g></svg>
												View Package Deals
											</button>
										</div>
									</div>
									<div class="row actions">
										<div class="col-xs-12 text-right">
											<a v-if="!cart.isEmpty()" target="_top" :href="checkoutLink" class="btn btn-sm checkout-button" :style="$mainButtonStyle">Checkout</a>
											<a data-dismiss="modal" class="btn btn-sm continue-button btn-success">Continue Shopping</a>
										</div>
									</div>

									<div class="row contact">
										<div class="col-xs-12 text-center">
											<p>Having problems with making a purchase? Please
												<a :href="contactLink" class="url-link" :style="$highlightColor" target="_top">contact us.</a>
											</p>
										</div>
									</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

	</div>
</template>

<script>
	import items from './../checkout/items.vue'
	import total from './../checkout/total.vue'
	import Configure from './../../mixins/configure'
	import shareCart from './../sharecart.vue'
  import CartItemsList from "../cart/cart-items-list";
  import CheckoutTotal from "../checkout/checkout-total";
  import GaLinkingParam from "../../../../shared/mixins/gaLinkingParam";

    export default {
		components: {
      CheckoutTotal,
      CartItemsList,
    		items,total,shareCart
		},
		computed: {
			cart() {
				return this.$store.state.cart
			},
			config () {
				return this.$store.state.currentConfig
			},
			hasCoupon() {
				return this.cart.couponApplied;
			},
			user() {
				return this.$store.state.user
			},
			cartEmpty() {
				return this.cart.getCart().length == 0
			},
            discountString() {
                return this.$store.state.coupon.discountString
            },
			checkoutLink() {
				let link = "/checkout";
				link += "?cart=" + this.cart.base64EncodedCart() + "&sales_tracking=" + (this.config.salesTracking ? this.config.salesTracking : "");

				if (this.$route.query.config_id != undefined) {
				link += "&config_id=" + this.$route.query.config_id;
				}

				if (this.gaLinkingParam) {
				link += "&" + this.gaLinkingParam;
				}

				return link;
			},
			contactLink() {
				return 'mailto:'+this.user.email;
			},
			showPackageDiscountsNotice() {
				return this.$store.state.showPackageDiscountsNotice
			},
			styles() {
				let highlightRgb = this.hexToRgb(this.$styleConfig.main.highlight_color.value)
				return {
					'--highlight-text-color': this.$styleConfig.main.highlight_color.value,
					'--faded-highlight-text-color': `rgba(${highlightRgb.r}, ${highlightRgb.g}, ${highlightRgb.b}, 0.25)`,
				}
			},
			licensesInCart() {
				return this.cart.licenseNamesInCart()
			}
		},
		mixins: [Configure, GaLinkingParam],
    methods: {
			// removeCouponFromCart() {
            // 	this.cart.unsetCoupon()
			//
			// 	this.$store.commit("coupon", {
			// 		error: false,
			// 		discountString: false,
            //         code: ""
			// 	})
			// }
			showPackageDiscounts() {
				$("#discountsModal").modal('show')
			}
    }
	}
</script>
